import { useEffect, useState } from "react"
import { checkOrderCount } from "../env"
const RefundCounter = () => {
	const [orderDigitsSplit, setorderDigitsSplit] = useState<any>([0, 0, 0, 0, 0])

	async function checkOrders() {
		const getOrderLeftCount: any = await checkOrderCount()
		if (getOrderLeftCount) {
			setorderDigitsSplit(getOrderLeftCount)
		} else {
			setorderDigitsSplit(["F", "E", "H", "L", "E", "R"])
		}
	}
	useEffect(() => {
		checkOrders()
	}, [])

	return (
		<div className="container mx-auto max-w-[1200px] pb-16 text-center ">
			<div className="mx-auto flex justify-center gap-2 self-center text-green drop-shadow-[0_4px_27px_rgba(0,0,0,0.25)]">
				{orderDigitsSplit.map((item, index) => (
					<div key={index}>
						<span className="refund-item rounded-[5px] bg-white  px-4  py-0 font-Veener text-[41px] leading-[38px]">{item}</span>
					</div>
				))}
			</div>
		</div>
	)
}

export default RefundCounter
